import {
  GET_SCANNED_IMAGE,
  GET_SCANNED_IMAGE_SUCCESS,
  GET_SCANNED_IMAGE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getScannedImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCANNED_IMAGE:
      return { ...state, loading: true };
    case GET_SCANNED_IMAGE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SCANNED_IMAGE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getScannedImageReducer;
